import { computed, type MaybeRef, unref } from "vue";
import { useI18n } from "vue-i18n";

import type { WordClass } from "@/types/inflection-trainer.type";

export function useInflectionTrainerWordClass(wordClass: MaybeRef<WordClass>) {
  const { t } = useI18n();

  const _wordClass = computed<WordClass>(() => unref(wordClass));

  const translatedWordClass = computed<string>(() => {
    switch (_wordClass.value) {
      case "noun":
        return t("inflection-trainer.word-classes.noun");
      case "verb":
        return t("inflection-trainer.word-classes.verb");
      case "adjective":
        return t("inflection-trainer.word-classes.adjective");
      default:
        return t("inflection-trainer.word-classes.unknown");
    }
  });

  return {
    wordClass: _wordClass,
    translatedWordClass
  };
}
